import { createColorKeys } from '~/utils/chakraUtils'

import { SiteNavigationColors } from './SiteNavigation.colors'
import { SiteNavigationCollapseTabColors } from './SiteNavigationCollapseTab.colors'
import { SiteNavigationTabColors } from './SiteNavigationTab.colors'

export const siteNavigationColors = {
  SiteNavigation: { ...SiteNavigationColors },
  SiteNavigationTab: { ...SiteNavigationTabColors },
  SiteNavigationCollapseTab: { ...SiteNavigationCollapseTabColors },
}

export const siteNavigationColorKeys = createColorKeys(siteNavigationColors)
